/*
 * Uploadly's photo field, worded for the new theme (owner 2026-10-07).
 *
 * The "Your photos" group label already heads the field, so Uploadly's own
 * "Select Your Image:" line repeated it, and its button said "UPLOAD IMAGE".
 * Both strings are Uploadly app settings, and those settings are SHARED with
 * the live theme, which must not change before cutover. So the new theme
 * adjusts the widget after Uploadly draws it:
 *   - the generic "Select Your Image:" line is hidden (a field Uploadly labels
 *     with anything else, e.g. "Car Image", keeps its label);
 *   - the open button reads the label custom-globals passes in
 *     (sis.upload_photo, or sis.upload_logo on the sign templates), upper-cased
 *     like the button text it replaces.
 * Uploadly redraws the widget (variant change, upload, remove), so a
 * MutationObserver re-applies both. Nothing else in the widget is touched.
 *
 * Markup relied on (live capture 2026-10-07, custom-metal-portrait):
 *   div#photouploadapp > div > div#selBtn_<random> > p[data-ph-product-id]
 *   button.uploadcare--widget__button_type_open (one text node)
 * If Uploadly changes it, this silently does nothing and the widget shows
 * its own wording again.
 */
(() => {
  const tag = document.getElementById('sis-uploadly');
  const label = ((tag && tag.dataset.uploadLabel) || 'Upload photo').trim();
  const buttonText = label.toLocaleUpperCase(document.documentElement.lang || undefined);
  const GENERIC_LABEL = /^select your image:?$/i;
  const OPEN_TEXT = /^upload image$/i;
  // Several Uploadly fields on one product (the house portrait, owner 2026-10-21):
  // the theme names each field and its button, in Uploadly's field order. One
  // field keeps the old behaviour (the section heading names it).
  const split = (v) => (v || '').split('|').map((x) => x.trim());
  const fieldLabels = split(tag && tag.dataset.fieldLabels);
  const fieldButtons = split(tag && tag.dataset.fieldButtons).map((x) => x && x.toLocaleUpperCase(document.documentElement.lang || undefined));

  function setText(el, text) {
    if (el.childNodes.length === 1 && el.firstChild.nodeType === Node.TEXT_NODE) {
      if (el.firstChild.textContent !== text) el.firstChild.textContent = text;
      return true;
    }
    return false;
  }

  function tidy(root) {
    const fields = root.querySelectorAll('[id^="selBtn_"]');
    const several = fields.length > 1 && fieldLabels.some(Boolean);
    if (several) {
      fields.forEach((field, i) => {
        const p = field.querySelector('p[data-ph-product-id]');
        if (p && fieldLabels[i] && GENERIC_LABEL.test(p.textContent.trim()) && setText(p, fieldLabels[i])) {
          p.style.removeProperty('display');
        }
        // only the first-upload state ("UPLOAD IMAGE", "UPLOAD LOGO"); after an
        // upload Uploadly says "CHANGE IMAGE" and that stays
        const button = field.querySelector('.uploadcare--widget__button_type_open');
        if (button && fieldButtons[i] && /^upload\b/i.test(button.textContent.trim())) setText(button, fieldButtons[i]);
      });
      // a field the theme has no name for falls through to the one-field rules
    }
    root.querySelectorAll('p[data-ph-product-id]').forEach((p) => {
      if (GENERIC_LABEL.test(p.textContent.trim())) p.style.setProperty('display', 'none', 'important');
    });
    root.querySelectorAll('.uploadcare--widget__button_type_open').forEach((button) => {
      const node = button.firstChild;
      if (button.childNodes.length === 1 && node.nodeType === Node.TEXT_NODE && OPEN_TEXT.test(node.textContent.trim())) {
        node.textContent = buttonText;
      }
    });
  }

  function attach() {
    const root = document.getElementById('photouploadapp');
    if (!root) return false;
    tidy(root);
    new MutationObserver(() => tidy(root)).observe(root, { childList: true, subtree: true, characterData: true });
    return true;
  }

  if (attach()) return;
  // Uploadly mounts after load; stop looking after 20 s on a page without it.
  const wait = new MutationObserver(() => {
    if (attach()) wait.disconnect();
  });
  wait.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => wait.disconnect(), 20000);
})();
